var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoy2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M421.293,375.466l-86.154-25.339l-65.171,43.447c-8.458,5.639-19.477,5.639-27.935,0l-65.171-43.447  l-86.154,25.339c-21.433,6.304-36.151,25.974-36.151,48.314v63.04c0,13.907,11.274,25.18,25.18,25.18h352.525  c13.907,0,25.18-11.274,25.18-25.18v-63.04C457.444,401.44,442.727,381.769,421.293,375.466z",
    fill: "#ff3737",
    "data-original": "#cdf5a0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M348.329,276.984H163.673c-27.814,0-50.361,22.547-50.361,50.361  c0,55.627,45.094,100.721,100.721,100.721h83.934c55.627,0,100.721-45.095,100.721-100.721  C398.69,299.531,376.142,276.984,348.329,276.984z",
    fill: "#552118",
    "data-original": "#b4f09b",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M346.095,302.164c18.27,0,25.444,23.695,10.243,33.83l-86.37,57.58  c-8.458,5.639-19.477,5.639-27.935,0l-86.37-57.58c-15.202-10.134-8.027-33.83,10.243-33.83H346.095z",
    fill: "#0a2417",
    "data-original": "#64dca0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M176.863,350.127l65.171,43.447c8.459,5.639,19.477,5.639,27.935,0l65.171-43.447h0.001l-2.309-0.679  c-10.716-3.152-18.075-12.987-18.075-24.157v-39.913h-117.51v39.913c0,11.17-7.359,21.005-18.075,24.157L176.863,350.127  L176.863,350.127z",
    fill: "#b67f5f",
    "data-original": "#b67f5f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M197.247,304.108c17.634,9.419,37.631,14.843,58.754,14.843c21.123,0,41.12-5.424,58.754-14.843  v-18.731H197.247V304.108z",
    fill: "#a06e50",
    "data-original": "#a06e50",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M369.313,159.475h-4.197V58.754l-218.23,16.787v83.934h-4.197c-11.589,0-20.984,9.394-20.984,20.984  c0,11.589,9.394,20.984,20.984,20.984h4.621c4.301,56.327,51.263,100.721,108.692,100.721s104.391-44.394,108.691-100.721h4.621  c11.589,0,20.984-9.395,20.984-20.984C390.297,168.87,380.902,159.475,369.313,159.475z",
    fill: "#cd916e",
    "data-original": "#cd916e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M331.542,75.541v-8.393l-184.656,8.393v83.934h-2.999c-10.976,0-20.979,7.897-22.072,18.819  c-1.258,12.56,8.572,23.149,20.875,23.149h4.621c4.299,56.327,51.261,100.721,108.69,100.721c5.741,0,11.34-0.559,16.84-1.414  c-52.297-8.071-92.381-53.143-92.381-107.7v-67.148c0-18.542,15.031-33.574,33.574-33.574h100.721  C324.026,92.328,331.542,84.812,331.542,75.541z",
    fill: "#b67f5f",
    "data-original": "#b67f5f",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M205.64,184.656c-4.639,0-8.393-3.758-8.393-8.393v-8.393c0-4.635,3.754-8.393,8.393-8.393   s8.393,3.758,8.393,8.393v8.393C214.034,180.898,210.28,184.656,205.64,184.656z",
    fill: "#5a4650",
    "data-original": "#5a4650",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M306.362,184.656c-4.639,0-8.393-3.758-8.393-8.393v-8.393c0-4.635,3.754-8.393,8.393-8.393   s8.393,3.758,8.393,8.393v8.393C314.755,180.898,311.001,184.656,306.362,184.656z",
    fill: "#5a4650",
    "data-original": "#5a4650",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M197.239,151.082c-3.959,0-7.484-2.811-8.238-6.848c-0.861-4.553,2.139-8.939,6.697-9.795   l16.787-3.148c4.631-0.869,8.951,2.152,9.795,6.705c0.861,4.553-2.139,8.939-6.697,9.795l-16.787,3.148   C198.271,151.037,197.747,151.082,197.239,151.082z",
    fill: "#64505a",
    "data-original": "#64505a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M314.763,151.082c-0.508,0-1.033-0.045-1.557-0.143l-16.787-3.148   c-4.557-0.857-7.557-5.242-6.697-9.795c0.852-4.553,5.18-7.57,9.795-6.705l16.787,3.148c4.557,0.857,7.557,5.242,6.697,9.795   C322.247,148.27,318.723,151.082,314.763,151.082z",
    fill: "#64505a",
    "data-original": "#64505a",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M222.427,0c-41.72,0-75.541,33.821-75.541,75.541h176.262c38.528,0,70.319-28.843,74.958-66.114  c0.622-5-3.353-9.427-8.391-9.427C389.715,0,222.427,0,222.427,0z",
    fill: "#5a4650",
    "data-original": "#5a4650",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M389.716,0H242.143c-11.809,9.545-20.693,22.564-25.074,37.509  c-3.117,10.632,5.148,21.245,16.228,21.245h137.22c14.861-11.996,25.129-29.454,27.597-49.372C398.73,4.398,394.738,0,389.716,0z",
    fill: "#64505a",
    "data-original": "#64505a",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M222.427,512H205.64V411.279c0-4.636,3.758-8.393,8.393-8.393l0,0c4.636,0,8.393,3.758,8.393,8.393   L222.427,512L222.427,512z",
    fill: "#d7dd42",
    "data-original": "#ffd164",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M306.362,512h-16.787V411.279c0-4.636,3.758-8.393,8.393-8.393l0,0c4.636,0,8.393,3.758,8.393,8.393   L306.362,512L306.362,512z",
    fill: "#d7dd42",
    "data-original": "#ffd164",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M256.001,243.41c-12.59,0-24.213-4.041-31.074-10.811c-3.303-3.254-3.336-8.57-0.082-11.869  s8.582-3.336,11.869-0.082c2.795,2.758,9.525,5.975,19.287,5.975s16.492-3.217,19.287-5.975c3.287-3.254,8.615-3.217,11.869,0.082  s3.221,8.615-0.082,11.869C280.215,239.369,268.591,243.41,256.001,243.41z",
    fill: "#a06e50",
    "data-original": "#a06e50",
    className: ""
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy2);
export default __webpack_public_path__ + "static/media/boy2.e00c32cf1e0b7f10923796013688b598.svg";
export { ForwardRef as ReactComponent };